import {get} from '../netApi/fetch';
export function checkVideo(tuanid: number = 0):Promise<boolean>{
    return new Promise((resolve, reject)=>{
        get('/tuan/checkcansendvideo', {tuanid, types: 1}).then((res:boolean)=>{
            resolve(res)
        }).catch((err:any) => {
            reject(err)
        })
    })
}